import React, { Component } from 'react';
import Prompt from '../components/Prompt';
import Page from '../../lib/page';
import * as emailLink from '../../../data/emailFormURL.json';
import prompt from '../constants/PromptData';
import experience from '../constants/UtilConstants';

const userExp = Page.getUserExperience();

class PromptContainer extends Component {

  static getPromptMessage(exp) {
    const currentUri = window.location.href;
    const prompts = [];
    switch (exp) {
      case experience.BUSINESS:
      case experience.TECHNICAL:
        if (!Page.isLoggedIn()) {
          prompts.push({
            key: 'nonSmc',
            message: prompt.nonSmc,
            buttonText: prompt.logoutButton,
            buttonLink: `${emailLink.signIn}${currentUri}`,
            fptiText: 'prompt:login',
            isNewTab: false,
          });
        }
        prompts.push({
          key: 'second',
          message: prompt.second,
          buttonText: prompt.emailButton,
          buttonLink: emailLink.visitPayPalStatus,
          fptiText: 'prompt:paypal status',
          isNewTab: true,
        });
        return prompts;

      case experience.PERSONAL:
      default :
        prompts.push({
          key: Page.isLoggedIn() ? 'first' : 'smc',
          message: Page.isLoggedIn() ? prompt.first : prompt.smc,
          buttonText: Page.isLoggedIn() ? prompt.loginButton : prompt.logoutButton,
          buttonLink: Page.isLoggedIn() ? emailLink.goToMessageCenterUrl : `${emailLink.signIn}${currentUri}`,
          fptiText: Page.isLoggedIn() ? 'prompt:smc' : 'prompt:login',
          isNewTab: false,
        });
        return prompts;
    }
  }
  static renderPrompts(prompts) {
    let promptBox = null;
    if (prompts && prompts.length >= 0) {
      promptBox = prompts.map(promptItem =>
        <Prompt
          key={promptItem.key}
          id={promptItem.key}
          message={promptItem.message}
          buttonText={promptItem.buttonText}
          buttonLink={promptItem.buttonLink}
          fptiText={promptItem.fptiText}
          isNewTab={promptItem.isNewTab}
        />,
      );
    }
    return promptBox;
  }
  render() {
    return (<div className="prompt-container">
      {PromptContainer.renderPrompts(PromptContainer.getPromptMessage(userExp))}
    </div>);
  }
}
export default PromptContainer;
